import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Header, Body, Typography } from "../styled";
// import { Typography } from "@mui/material";
import { format, formatISO } from "date-fns";
import Stack from "@mui/material/Stack";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";





const Passport: FC = () => {
    return (
      <Box mt={1}>
        <Header>
            <Box display='flex'>
                <TextField
                    label="Документ, удостоверяющий личность(паспорт)"
                    variant="outlined"
                    size="small"
                    sx={{ mr: 1, width: "500px" }}
                />
                <TextField
                    label="серия"
                    variant="outlined"
                    size="small"
                    sx={{ mr: 1, width: "200px" }}
                />
                <TextField
                    label="номер"
                    variant="outlined"
                    size="small"
                    sx={{ mr: 1, mb: 1, width: "200px" }}
                />
            </Box>
                <TextField 
                    label="Кем выдан"
                    variant="outlined"
                    size="small"
                    sx={{ width: "800px", mb: 1 }}
                />
            <Box display='flex'>
                <TextField
                    label="Дата выдачи"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    label="Подразделение"
                    variant="outlined"
                    size="small"
                    sx={{width: "200px",mb: 1 }}
                />
            </Box>
        </Header>
        <Body>
        <Typography sx={{mb: 1, ml: 1}}> Адрес по паспорту: </Typography>
            <TextField
                label="район"
                variant="outlined"
                size="small"
                sx={{ width: "500px", mb: 1 }}
            />
            <TextField
                label="город, село"
                variant="outlined"
                size="small"
                sx={{ width: "500px", mb: 1 }}
            />
            <TextField
                label="улица"
                variant="outlined"
                size="small"
                sx={{ width: "500px", mb: 1 }}
            />
            <TextField
                label="Дом, квартира"
                variant="outlined"
                size="small"
                sx={{ width: "500px", mb: 1 }}
            />
            <TextField
                label="индекс"
                variant="outlined"
                size="small"
                sx={{ width: "200px", mb: 1 }}
            />
            <TextField
                label="дата регистраци"
                value={format(1683886255004, "dd.MM.yyyy")}
                variant="outlined"
                size="small"
                sx={{ width: "200px", mb: 1 }}
            />
            <TextField
                label="Телефон"
                variant="outlined"
                size="small"
                sx={{ width: "200px", mb: 1 }}
            />
            <Typography sx={{mb: 1, ml: 1}}> Адрес фактический: </Typography>
            <TextField
                label="Адрес"
                variant="outlined"
                size="small"
                sx={{ width: "800px", mb: 1 }}
            />
            <TextField
                label="Индекс"
                variant="outlined"
                size="small"
                sx={{ width: "200px", mb: 1 }}
            />
        </Body>
      </Box>
    );
  };

export default Passport;
